import React from 'react';
import { useTranslation } from "react-i18next";
import { shortId } from "../../../utils/text-formatting.utils";
import OperatorIcon from '../../../assets/icons/operator.svg';
import SupervisorIcon from '../../../assets/icons/supervisor.svg';
import { UserRole } from '../../../models/enums/user-role.enum';

interface UserShiftItemProps {
    firstName: string;
    lastName: string;
    userId: string;
    userRole: UserRole;
}

const UserShiftItem: React.FC<UserShiftItemProps> = ({
    firstName,
    lastName,
    userId,
    userRole
}) => {
    const { t } = useTranslation();
    const isOperator = userRole === UserRole.Operator;

    return (
        <div className='flex items-center px-3 py-2 hover:bg-gray-800'>
            <div className='flex items-center flex-1 gap-4'>
                <div className="flex items-center min-w-32">
                    <img 
                        src={isOperator ? OperatorIcon : SupervisorIcon} 
                        alt={isOperator ? "operator" : "supervisor"} 
                        className="w-6 h-6 mr-2" 
                    />
                    <span className="text-sm whitespace-nowrap">
                        {t(isOperator ? 'shiftAssignmentPage.operator' : 'shiftAssignmentPage.supervisor')}
                    </span>
                </div>
                <span className="text-sm">
                    {firstName} {lastName}
                </span>
            </div>
            <span className="text-xs text-gray-400">
                {shortId(userId)}
            </span>
        </div>
    );
};

export default UserShiftItem; 